import type { PanelDrawing } from "@/features/drawings/panel/types";
import { listQuotationDrawings, type QuotationDrawing } from "./api";

/**
 * 図面一覧の取り置き（react-query）。**同じキーには必ずこの取り方を使う**。
 *
 * タブの件数表示もここから引く。キーが同じで取り方だけ違うと、**先に走ったほうの
 * 形がキャッシュに残り**、あとから読む側が別の形を受け取る。実際にそれで、紐付け
 * 済みの図面がカードで「紐付無し」に見える不具合を出した（件数を出すだけの問い
 * 合わせが、下の写し替えを通らない生の応答でキャッシュを埋めていた）。
 */
export function quotationDrawingsQuery(quotationId: number) {
  return {
    queryKey: ["quotation-drawings", quotationId] as const,
    queryFn: async (): Promise<{
      items: PanelDrawing[];
      unmatched_count: number;
    }> => {
      const res = await listQuotationDrawings(quotationId);
      return {
        items: res.items.map(toPanelDrawing),
        unmatched_count: res.unmatched_count,
      };
    },
  };
}
/** 見積の図面を、パネルが扱う中立な形へ写す。 */
function toPanelDrawing(drawing: QuotationDrawing): PanelDrawing {
  return {
    ...drawing,
    item_id: drawing.quotation_item_id,
    // 案件に引き継がれた図面は**同じ 1 枚を案件と共有している**ので、見積側からは
    // 削除できない（API が 409 を返す）。紐付けの変更は見積側が決めてよい
    // （[[drawing_project_link]] の追従は見積 → 案件の一方向）。
    origin_note: drawing.project_number
      ? `案件 ${drawing.project_number} で使用中`
      : null,
    can_delete: drawing.project_number == null,
    can_relink: true,
    // 図番は見積の側が持つ（案件に引き継いだあとでもここで直せる）。
    can_edit_number: true,
  };
}
